import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export class LoginIdentifierRequiredError extends Error {
  constructor() {
    super('Keep a mobile number or email so this employee can sign in.');
    this.name = 'LoginIdentifierRequiredError';
  }
}

/** Login identifiers must have one canonical form, including rate-limit keys. */
export function normalizeLoginPhone(value: string): string | null {
  const raw = value.trim();
  if (raw.length > 64 || !/^\+?[\d\s().-]+$/.test(raw)) return null;
  const phone = parsePhoneNumberFromString(raw, 'US');
  return phone?.isValid() ? phone.number : null;
}

export function normalizeLoginIdentifier(value: string): string | null {
  const raw = value.trim();
  if (raw.includes('@')) return raw.toLowerCase();
  return normalizeLoginPhone(raw);
}
